import { ToastConfig } from '../../apps/professional-app/fa/MeetingSummary/Toast/MeetingSummaryToast'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { SidebarType } from '../../apps/professional-app/fa/MeetingSummary/Sidebar/models'

interface DisplayState {
  sidebar: {
    displayedSidebar: SidebarType | null
    title: string
    icon: string
  }
  edit: {
    editingAiResultIds: string[]
  }
  toast: {
    toastConfig: ToastConfig | null
    showToast: boolean
  }
  preparation: {
    stopOnly: boolean
  }
}

const initialState: DisplayState = {
  sidebar: {
    displayedSidebar: null,
    title: '',
    icon: '',
  },
  edit: {
    editingAiResultIds: [],
  },
  toast: {
    toastConfig: null,
    showToast: false,
  },
  preparation: {
    stopOnly: false,
  },
}

export const displaySlice = createSlice({
  name: 'display',
  initialState,
  reducers: {
    displaySidebar: (state, action: PayloadAction<{ type: SidebarType; title: string; icon: string }>) => {
      const { type, title, icon } = action.payload
      state.sidebar.displayedSidebar = type
      state.sidebar.title = title
      state.sidebar.icon = icon
    },
    hideSidebar: (state) => {
      state.sidebar.displayedSidebar = null
    },
    startEditingAiResult: (state, action: PayloadAction<string>) => {
      state.edit.editingAiResultIds.push(action.payload)
    },
    stopEditingAiResult: (state, action: PayloadAction<string>) => {
      state.edit.editingAiResultIds = state.edit.editingAiResultIds.filter((aiResultId) => aiResultId !== action.payload)
    },
    stopEditingAiResults: (state) => {
      state.edit.editingAiResultIds = []
    },
    showToast: (state, action: PayloadAction<ToastConfig>) => {
      state.toast.toastConfig = action.payload
      state.toast.showToast = true
    },
    hideToast: (state) => {
      state.toast.toastConfig = null
      state.toast.showToast = false
    },
    setPreparationStopOnly: (state, action: PayloadAction<boolean>) => {
      state.preparation.stopOnly = action.payload
    },
    resetDisplay: () => initialState,
  },
})

export const {
  displaySidebar,
  hideSidebar,
  startEditingAiResult,
  stopEditingAiResult,
  stopEditingAiResults,
  showToast,
  hideToast,
  setPreparationStopOnly,
  resetDisplay,
} = displaySlice.actions

export const selectDisplayedSidebar = (state: RootState) => state.meetingSummary.display.sidebar

export const selectEditingAiResultIds = (state: RootState) => state.meetingSummary.display.edit.editingAiResultIds

export const selectShowToast = (state: RootState) => state.meetingSummary.display.toast.showToast

export const selectToastConfig = (state: RootState) => state.meetingSummary.display.toast.toastConfig

export const selectPreparationStopOnly = (state: RootState) => state.meetingSummary.display.preparation.stopOnly
